import { SeveritiesSet } from './AlertSeverityHelpers';
import { isoDateParser } from 'utils/isoDateParser';

const LOCAL_STORAGE_KEY = 'AlertsSearchCriteria';

export interface AlertsSearchCriteria {
  selectedSeverities: SeveritiesSet;
  alertStatus: AlertStatus;
  startDate?: Date;
  endDate?: Date;
  sortBy: string;
}

export enum AlertStatus {
  Open = 'Open',
  Closed = 'Closed',
  Ignored = 'Ignored',
  All = 'All'
}

export function saveAlertsSearchCriteria(tenantName: string, criteria: Partial<AlertsSearchCriteria>): void {
  return window.localStorage.setItem(getTenantKey(tenantName), JSON.stringify(criteria));
}

export function loadAlertsSearchCriteria(tenantName: string): AlertsSearchCriteria | null {
  const json = window.localStorage.getItem(getTenantKey(tenantName));
  if (!json) return null;
  try {
    return JSON.parse(json, isoDateParser);
  } catch (e) {
    console.error(`'${json}' is not a valid JSON`);
    clearAlertsSearchCriteriaForTenant(tenantName);
    return null;
  }
}

export function clearAlertsSearchCriteriaForTenant(tenantName: string): void {
  window.localStorage.removeItem(getTenantKey(tenantName));
}

export function clearAllAlertsSearchCriteria(): void {
  const keyPrefix = getTenantKey('');
  for (let i = window.localStorage.length - 1; i >= 0; i--) {
    const key = window.localStorage.key(i);
    if (key?.startsWith(keyPrefix)) {
      window.localStorage.removeItem(key);
    }
  }
}

const getTenantKey = (tenantName: string): string => `${LOCAL_STORAGE_KEY}/${tenantName}`;
